import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState } from 'react';
export const CategoryNavigationContext = createContext({
    isDropdownOpen: false,
    setDropdownOpen: () => { },
});
export const CategoryNavigationProvider = ({ children, }) => {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const setDropdownState = (open) => {
        setIsDropdownOpen(open);
    };
    return (_jsx(CategoryNavigationContext.Provider, { value: { isDropdownOpen, setDropdownOpen: (open) => setDropdownState(open) }, children: children }));
};
export const useCategoryNavigationContext = () => useContext(CategoryNavigationContext);
//# sourceMappingURL=CategoryNavigation.context.js.map